/// <reference path='references.ts' />

class DropdownUtil {

    public static calculateWidth($this: JQuery, clazz: string): number {

        let width;
        let $container;
        if ($this.is(':visible')) {
            let $offScreen = $this.closest('.off-screen');
            if ($offScreen.length > 0) {
                // if the dropdown is offscreen then the width will not be constrained by the container. By getting the width of the container
                // and temporarily applying it to the off-screen panel we can get a reasonable estimate of the layout when moved on-screen.
                $container = $offScreen.parent();
                // copy the width from the container to the off-screen panel
                $offScreen.width($container.width());
                // now get the probable width of the dropdown
                width = $this.width();
                // reset width (assumes container did not originally have an explicit width)
                $offScreen.css('width', '');
            } else {
                width = $this.width();
            }

        } else {
            // if the select is hidden then the width will not calculate correctly, but using the closest visible container should be a reasonable estimate (e.g. might be a td)
            width = $this.closest(':visible').width();
            // If the width is the same as the form/.panel-content width then this is likely too big
            $container = $this.closest('form,.panel-content,.container');
            if ($container.length > 0 && width === $container.width()) {
                // Try basing the width on another visible dropdown in the same form
                let $otherDropdown = $container.find(clazz + ':visible:first');
                if ($otherDropdown.length > 0) {
                    width = $otherDropdown.width();
                } else {
                    // fallback to 165 (i.e. default width of a form field)
                    width = 165;
                }
            }
        }
        return width;
    }
}
